/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { PoliciesV2 } from '../models';
// @ts-ignore
import type { Status } from '../models';
/**
 * PoliciesV2APIApi - axios parameter creator
 * @export
 */
export const PoliciesV2APIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Gets V2 policies configuration for the target cluster.
         * @summary Get cluster policies
         * @param {string} clusterId The ID of the cluster.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        policiesV2APIGetClusterPolicies: async (clusterId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('policiesV2APIGetClusterPolicies', 'clusterId', clusterId)
            const localVarPath = `/cluster-autoscaler/v2/clusters/{clusterId}/policies`
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates cluster\'s V2 policies configuration.
         * @summary Update cluster policies
         * @param {string} clusterId The ID of the cluster.
         * @param {PoliciesV2} policiesV2 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        policiesV2APIUpdateClusterPolicies: async (clusterId: string, policiesV2: PoliciesV2, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('policiesV2APIUpdateClusterPolicies', 'clusterId', clusterId)
            // verify required parameter 'policiesV2' is not null or undefined
            assertParamExists('policiesV2APIUpdateClusterPolicies', 'policiesV2', policiesV2)
            const localVarPath = `/cluster-autoscaler/v2/clusters/{clusterId}/policies`
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(policiesV2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PoliciesV2APIApi - functional programming interface
 * @export
 */
export const PoliciesV2APIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PoliciesV2APIApiAxiosParamCreator(configuration)
    return {
        /**
         * Gets V2 policies configuration for the target cluster.
         * @summary Get cluster policies
         * @param {string} clusterId The ID of the cluster.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async policiesV2APIGetClusterPolicies(clusterId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PoliciesV2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.policiesV2APIGetClusterPolicies(clusterId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PoliciesV2APIApi.policiesV2APIGetClusterPolicies']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates cluster\'s V2 policies configuration.
         * @summary Update cluster policies
         * @param {string} clusterId The ID of the cluster.
         * @param {PoliciesV2} policiesV2 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async policiesV2APIUpdateClusterPolicies(clusterId: string, policiesV2: PoliciesV2, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PoliciesV2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.policiesV2APIUpdateClusterPolicies(clusterId, policiesV2, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PoliciesV2APIApi.policiesV2APIUpdateClusterPolicies']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PoliciesV2APIApi - factory interface
 * @export
 */
export const PoliciesV2APIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PoliciesV2APIApiFp(configuration)
    return {
        /**
         * Gets V2 policies configuration for the target cluster.
         * @summary Get cluster policies
         * @param {PoliciesV2APIApiPoliciesV2APIGetClusterPoliciesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        policiesV2APIGetClusterPolicies(requestParameters: PoliciesV2APIApiPoliciesV2APIGetClusterPoliciesRequest, options?: RawAxiosRequestConfig): AxiosPromise<PoliciesV2> {
            return localVarFp.policiesV2APIGetClusterPolicies(requestParameters.clusterId, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates cluster\'s V2 policies configuration.
         * @summary Update cluster policies
         * @param {PoliciesV2APIApiPoliciesV2APIUpdateClusterPoliciesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        policiesV2APIUpdateClusterPolicies(requestParameters: PoliciesV2APIApiPoliciesV2APIUpdateClusterPoliciesRequest, options?: RawAxiosRequestConfig): AxiosPromise<PoliciesV2> {
            return localVarFp.policiesV2APIUpdateClusterPolicies(requestParameters.clusterId, requestParameters.policiesV2, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for policiesV2APIGetClusterPolicies operation in PoliciesV2APIApi.
 * @export
 * @interface PoliciesV2APIApiPoliciesV2APIGetClusterPoliciesRequest
 */
export interface PoliciesV2APIApiPoliciesV2APIGetClusterPoliciesRequest {
    /**
     * The ID of the cluster.
     * @type {string}
     * @memberof PoliciesV2APIApiPoliciesV2APIGetClusterPolicies
     */
    readonly clusterId: string
}

/**
 * Request parameters for policiesV2APIUpdateClusterPolicies operation in PoliciesV2APIApi.
 * @export
 * @interface PoliciesV2APIApiPoliciesV2APIUpdateClusterPoliciesRequest
 */
export interface PoliciesV2APIApiPoliciesV2APIUpdateClusterPoliciesRequest {
    /**
     * The ID of the cluster.
     * @type {string}
     * @memberof PoliciesV2APIApiPoliciesV2APIUpdateClusterPolicies
     */
    readonly clusterId: string

    /**
     * 
     * @type {PoliciesV2}
     * @memberof PoliciesV2APIApiPoliciesV2APIUpdateClusterPolicies
     */
    readonly policiesV2: PoliciesV2
}

/**
 * PoliciesV2APIApi - object-oriented interface
 * @export
 * @class PoliciesV2APIApi
 * @extends {BaseAPI}
 */
export class PoliciesV2APIApi extends BaseAPI {
    /**
     * Gets V2 policies configuration for the target cluster.
     * @summary Get cluster policies
     * @param {PoliciesV2APIApiPoliciesV2APIGetClusterPoliciesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoliciesV2APIApi
     */
    public policiesV2APIGetClusterPolicies(requestParameters: PoliciesV2APIApiPoliciesV2APIGetClusterPoliciesRequest, options?: RawAxiosRequestConfig) {
        return PoliciesV2APIApiFp(this.configuration).policiesV2APIGetClusterPolicies(requestParameters.clusterId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates cluster\'s V2 policies configuration.
     * @summary Update cluster policies
     * @param {PoliciesV2APIApiPoliciesV2APIUpdateClusterPoliciesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoliciesV2APIApi
     */
    public policiesV2APIUpdateClusterPolicies(requestParameters: PoliciesV2APIApiPoliciesV2APIUpdateClusterPoliciesRequest, options?: RawAxiosRequestConfig) {
        return PoliciesV2APIApiFp(this.configuration).policiesV2APIUpdateClusterPolicies(requestParameters.clusterId, requestParameters.policiesV2, options).then((request) => request(this.axios, this.basePath));
    }
}

